export function uid(): string {
    return Math.floor(Math.random() * (36 ** 6)).toString(36);
}
